import { render, staticRenderFns } from "./ModificarHorarioPro.vue?vue&type=template&id=656c3910&scoped=true&"
import script from "./ModificarHorarioPro.vue?vue&type=script&lang=js&"
export * from "./ModificarHorarioPro.vue?vue&type=script&lang=js&"
import style0 from "./ModificarHorarioPro.vue?vue&type=style&index=0&id=656c3910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656c3910",
  null
  
)

export default component.exports